import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllContact = createAsyncThunk(
  "Inquiry/FindAllInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiry/FindAllInquiry`,
        formdata
      );
      const result = response.data?.Data;
      return result?.map((data: any) => {
        return {
          ...data,
          Name: `${data?.FirstName} ${data?.LastName}`,
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
